<template>
    <div class="row">
        <div class="col-md-3">
            <div class="card left_filter_card_bg">
                <div class="card-body">
                    <div
                        class="form-group"
                        v-if="auth_user && auth_group != ''"
                    >
                        <label class="title_label">Group</label>
                        <select
                            class="form-control"
                            v-model="selectedGroup"
                            @change="getProduct()"
                        >
                            <option value="open">Open for all users</option>
                            <option value="close">
                                For only group members
                            </option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label class="title_label">Category</label>
                        <select
                            class="form-control"
                            v-model="selectedCategory"
                            @change="getProduct()"
                        >
                            <option
                                v-for="data in category"
                                :key="data.slug"
                                :value="data.id"
                            >
                                {{ data.name }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group" v-if="subCategory.length > 0">
                        <label class="title_label">Sub Category</label>
                        <select
                            class="form-control"
                            v-model="selectedsubCategory"
                            @change="getProduct()"
                        >
                            <option value="">Select Sub category</option>
                            <option
                                v-for="data in subCategory"
                                :key="data.slug"
                                :value="data.id"
                            >
                                {{ data.name }}
                            </option>
                        </select>
                    </div>

                    <!-- <div class="form-group" id="attribute" v-if="attribute.length > 0">
            <div id="datas">
              <div v-for="data in attribute" :key="data.slug">
                <label class="title_label">{{ data.title }}</label>
                <input
                  class="form-check-input"
                  type="hidden"
                  id="attribute_id"
                  name="attribute_id"
                  value="25"
                />
                <div class="filter_box_scroll">
                  <div
                    class="form-check"
                    v-for="data2 in data.attribute_option"
                    :key="data2.id"
                  >
                    <input
                      class="form-check-input atttribute_value"
                      :name="`atttribute_value_${data.code}[]`"
                      :id="`atttribute_value_${data.code}_${data2.id}`"
                      type="checkbox"
                      :value="data2.id"
                      v-model="selectedAttribute"
                      @change="getProduct()"
                    />
                    <label class="form-check-label" for="">{{
                      data2.admin_name
                    }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
                </div>
            </div>
        </div>

        <div class="col-md-9 product_right_list_content" id="product_list">
            <div class="d-flex justify-content-between align-items-center">
                <div>
                    Products In <b>{{ this.city }}</b>
                </div>
                <div class="product_list_head">
                    <h1 class="title"></h1>
                    <div class="sorting">
                        <select class="form-control">
                            <option>Default Sorting</option>
                        </select>
                    </div>
                </div>
            </div>

            <div v-if="product.data.length != 0">
                <div class="product_item_bg">
                    <div
                        class="item"
                        v-for="data in product.data"
                        :key="data.id"
                    >
                        <div class="card">
                            <div class="card-body">
                                <a
                                    :href="'/reuse/' + data.slug"
                                    class="pro_img"
                                >
                                    <img
                                        :src="
                                            getServerImageUrl(
                                                data.prdouct_image[0].path
                                            )
                                        "
                                        class="card-img-top img-fluid"
                                        alt="product"
                                    />
                                </a>
                                <h5 class="card-title">
                                    <a :href="'/reuse/' + data.slug">
                                        <div
                                            v-for="detial in data.product_attribute"
                                            :key="detial.id"
                                        >
                                            <div
                                                v-if="
                                                    detial.attribute_id == '2'
                                                "
                                                :key="data.id"
                                            >
                                                {{ detial.value }}
                                            </div>
                                        </div>
                                    </a>
                                </h5>
                                <div class="text-left">
                                    <span
                                        v-for="detial in data.product_attribute"
                                        :key="detial.id"
                                    >
                                        <span
                                            v-if="detial.attribute_id == '9'"
                                            :key="data.id"
                                            class="text-left"
                                        >
                                            <i
                                                class="las la-comment"
                                                title="Description"
                                            ></i>
                                            {{
                                                detial.attribute_value[0]
                                                    .admin_name
                                            }}
                                        </span>
                                    </span>
                                </div>
                                <figcaption>
                                    <div class="text-left">
                                        <span
                                            v-if="data.category"
                                            :key="data.category.id"
                                            class="text-left"
                                        >
                                            <i
                                                class="las la-info"
                                                title="Category"
                                            ></i>
                                            {{ data.category.name }}
                                        </span>
                                    </div>
                                    <div class="text-left">
                                        <span
                                            v-if="data.subcategory_points"
                                            :key="data.subcategory_points.id"
                                            class="text-left"
                                        >
                                            <!-- <i class="las la-star" title="Points"></i> -->
                                            <img
                                                :src="'/assets/images/green-points-icon.jpeg'"
                                                class="img-fluid green_icon"
                                                alt="product"
                                            />
                                            {{
                                                data.subcategory_points
                                                    .reuse_points
                                            }}
                                        </span>
                                    </div>
                                    <div class="text-left">
                                        <span
                                            v-if="data.front_user"
                                            :key="data.front_user.id"
                                            class="text-left"
                                        >
                                            <i
                                                class="las la-user-circle"
                                                title="Posted By"
                                            ></i>
                                            {{ data.front_user.first_name }}
                                            {{ data.front_user.last_name }}
                                        </span>
                                    </div>
                                </figcaption>
                            </div>
                            <div class="card-footer">
                                <div class="product-block-btn">
                                    <a
                                        :href="'/reuse/' + data.slug"
                                        class="btn btn-secondary"
                                    >
                                        <img
                                            src="/assets/images/right-arrow-circle-black-icon.svg"
                                            class="img-fluid"
                                            alt="Read More"
                                        />
                                        Read More
                                    </a>
                                    <button
                                        class="btn btn-success"
                                        :onclick="'addcart(' + data.id + ')'"
                                    >
                                        <img
                                            src="/assets/images/participate-icon.svg"
                                            class="img-fluid"
                                            alt="Buy"
                                        />
                                        Buy
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="product.data.length == 0">
                <span class="text-center text-danger ml-auto mr-auto mt-3"
                    ><b> There Is No Reuse Product ! </b></span
                >
            </div>

            <pagination
                align="center"
                :data="product"
                @pagination-change-page="getProduct"
            >
            </pagination>
        </div>
    </div>
</template>
<script>
import { getServerImageUrl } from "../../getimage";
export default {
    name: "ProductIndex",
    props: ["secategory", "auth_group", "auth_user"],

    data() {
        return {
            city: localStorage.getItem("city"),
            category: [],
            subCategory: [],
            attribute: [],
            product: {},
            group: [],
            selectedCategory: null,
            selectedsubCategory: null,
            selectedAttribute: [],
            selectedGroup: "open",
            getServerImageUrl,
        };
    },
    created() {
        if (this.secategory) {
            this.selectedCategory = this.secategory;
        }
    },
    mounted() {
        this.getProduct();
    },
    methods: {
        getProduct(page = 1) {
            var url = "/products";
            axios
                .get(url, {
                    params: {
                        category: this.selectedCategory,
                        sub_category: this.selectedsubCategory,
                        attribute: this.selectedAttribute,
                        page: page,
                        group: this.selectedGroup,
                    },
                })
                .then((response) => {
                    this.category = response.data.category;
                    this.subCategory = response.data.sub_category;
                    this.attribute = response.data.attribute;
                    console.log(response.data.product);
                    this.product = response.data.product;
                    this.group = response.data.group;
                })
                .catch((error) => {
                    // handle error
                    console.log(error);
                });
        },
    },
};
</script>
